export default {
  termsAndCondition: {
    id: 'checkout_services_bouygues_phoneline_setup_terms_and_conditions',
    defaultMessage:
      'Je certifie l’exactitude des informations ci-dessus et reconnais avoir préalablement lu et accepté les {termsOfDistanceSelling, html}, les {termsOfService, html}, les {termsOfPricing, html}, le {contractualSummary, html} et j’ai pris connaissance du traitement de mes données tel que décrit dans la {privacyPolicy, html} de Bouygues Telecom.',
  },
  termsOfDistanceSelling: {
    id: 'checkout_services_bouygues_phoneline_setup_terms_and_conditions_of_distance_selling',
    defaultMessage: 'Conditions Générales de Vente à distance',
  },
  termsOfService: {
    id: 'checkout_services_bouygues_phoneline_setup_terms_and_conditions_of_service',
    defaultMessage: 'Conditions Générales de Service',
  },
  termsOfPricing: {
    id: 'checkout_services_bouygues_phoneline_setup_terms_and_conditions_of_pricing',
    defaultMessage: 'tarifs',
  },
  contractualSummary: {
    id: 'checkout_services_bouygues_phoneline_setup_terms_and_conditions_contractual_summary',
    defaultMessage: 'récapitulatif contractuel',
  },
  privacyPolicy: {
    id: 'checkout_services_bouygues_phoneline_setup_terms_and_conditions_privacy_policy',
    defaultMessage: 'Politique de Confidentialité',
  },
}
